import { Button } from "antd";
import LabeledInput from "components/Form/LabeledInput";
import InfoIcon from "components/Icons/InfoIcon";
import useCreateCity from "hooks/cities/useCreateCity";

export default function CreateCity() {
  const { control, handleSubmit, loading, onSubmit } = useCreateCity();

  return (
    <div
      className="w-full bg-white rounded-lg p-6"
      style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
    >
      <div className="w-full pt-5 pb-5">
        <div className="w-full">
          <h1 className="p-5 font-light text-lg text-center">Add New City</h1>
          <div className="w-full">
            <div className="w-full relative h-1 top-7 overflow-clip rounded-md">
              <div className="w-1/2 bg-black h-full rounded-md"></div>
            </div>
            <div className="relative w-full flex justify-center">
              <div className="relative h-14 w-14 bg-black rounded-full flex items-center justify-center text-white text-2xl">
                <InfoIcon />
              </div>
            </div>
          </div>
          <p className="text-center mt-2 text-sm font-normal">
            City Information
          </p>
        </div>
        <div className="w-full py-8 px-5">
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="w-full flex flex-wrap justify-center"
          >
            <div className="w-full px-4 pt-5 md:w-1/2">
              <LabeledInput
                label="Name"
                type="text"
                control={control}
                name="name"
                placeholder="Name"
              />
            </div>
            <div className="w-full flex mt-8 justify-end">
              <Button
                loading={loading}
                htmlType="submit"
                type="primary"
                className="py-2 px-8 rounded-md float-right h-auto font-medium w-fit shadow-none"
              >
                Add City
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
